if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  (function (F) {
    var r, G, u, C, t, H, I, J, y, K, L, M, N, O, D, E;
    r = (function (v) {
      function f(a) {
        if (!e.test(a)) throw Error();
        a = a.split('.');
        for (var b = window, c = 0; c < a.length; c++) b = b[a[c]];
        return b;
      }

      function g(a, b) {
        return 'string' === typeof a &&
          'string' === typeof b &&
          a.length >= b.length
          ? a.substr(0, b.length) === b
          : !1;
      }

      var d = /^\/\//,
        c = /^[^:]+:/,
        b = /^https?:\/\/[^\/]+/,
        a = / (?:MSIE |Trident\/7\.0;.* rv:)(\d+)/,
        e = /^[^.]+(?:\.[^.]+)*$/;
      return {
        Y: v,
        startsWith: g,
        B: function (a) {
          for (var b = 0; b < a.length; b++)
            try {
              var e = f(a[b]);
              if (e) return e;
            } catch (c) {}
          return '';
        },
        a: f,
        O: function (a) {
          d.test(a) && (a = document.URL.match(c)[0] + a);
          return (a = a.match(b)) && !g(document.URL, a[0]) ? !1 : !0;
        },
        D: function () {
          var b = navigator.userAgent.match(a);
          return b ? parseInt(b[1], 10) : null;
        },
        F: function () {
          return window.XMLHttpRequest
            ? new XMLHttpRequest()
            : new ActiveXObject('Microsoft.XMLHTTP');
        },
        R: function (a, b, e) {
          var c = !1,
            d = !1,
            f = !1;
          try {
            var g = null,
              q = !1,
              A = function () {
                a.onreadystatechange = null;
                null !== g && (clearTimeout(g), (g = null));
                q = !0;
              };
            a.onreadystatechange = function () {
              q || 4 !== a.readyState || (A(), (a = null), e(d, f));
            };
            0 !== b &&
              (g = setTimeout(function () {
                q || ((d = !0), A(), a.abort(), (a = null), e(d, f));
              }, b));
            a.send();
            c = !0;
          } catch (P) {
            (f = !0), A(), (a = null);
          } finally {
            c || e(d, f);
          }
        },
        G: function (a, b, e, c) {
          'boolean' === typeof c && c
            ? (b = a.split(b))
            : ((c = a.indexOf(b)),
              (b =
                -1 === c
                  ? [a]
                  : [a.substring(0, c), a.substring(c + b.length)]));
          a = b[0];
          for (c = 1; c < b.length; c++) a += e + b[c];
          return a;
        },
        Ga: function (a) {
          if (!a) return 0;
          if (Array.prototype.reduce)
            return a.split('').reduce(function (a, b) {
              a = (a << 5) - a + b.charCodeAt(0);
              return a & a;
            }, 0);
          for (var b = 0, c = 0, e = a.length; c < e; c++)
            (b = (b << 5) - b + a.charCodeAt(c)), (b = b & b);
          return b;
        },
        I: function (a) {
          return 0 <= window.navigator.userAgent.indexOf(a);
        },
      };
    })(function (v) {
      var f;
      try {
        if (
          ((f = document.getElementById(v)),
          null === f || 'undefined' === typeof f)
        )
          f = document.getElementsByName(v)[0];
      } catch (a) {}
      if (null === f || 'undefined' === typeof f)
        for (var g = 0; g < document.forms.length; g++)
          for (var d = document.forms[g], c = 0; c < d.elements.length; c++) {
            var b = d[c];
            if (b.name === v || b.id === v) return b;
          }
      return f;
    });
    G = (function () {
      return function (v) {
        v = ('0000000' + (((v / 1e3) | 0) >>> 0).toString(16)).slice(-8) + '-';
        for (var f = 9; 36 > f; f++) {
          var g;
          13 === f || 18 === f || 23 === f
            ? (g = '-')
            : 14 === f
            ? (g = '4')
            : ((g = (16 * Math.random()) | 0),
              19 === f && (g = (g & 3) | 8),
              (g = g.toString(16)));
          v += g;
        }
        return v;
      };
    })();
    u = {
      j: [],
      K: [],
      l: 9e3,
      w: null,
      S: [],
      v: null,
      Ma: '@_PAYLOADINPUTID_@',
    };
    C = function f() {
      function g(c, e, d) {
        if (0 === b) for (b = c, a = d; e.length; ) e.shift().call(h, d);
      }

      function d(b, c) {
        setTimeout(function () {
          try {
            var e = c.call(null, a);
            e instanceof Object && e.then && e.then instanceof Function
              ? e.then(b.C, b.reject)
              : b.C(e);
          } catch (d) {
            b.reject(d);
          }
        }, 0);
      }

      function c(a, c, f) {
        b === f
          ? d(a, c)
          : (1 === f ? e : k).push(function () {
              d(a, c);
            });
      }

      var b = 0,
        a,
        e = [],
        k = [],
        h = this;
      this.C = function (a) {
        g(1, e, a);
      };
      this.reject = function (a) {
        g(-1, k, a);
      };
      this.then = function (a, b) {
        var e = new f();
        a instanceof Function && c(e, a, 1);
        b instanceof Function && c(e, b, -1);
        return e;
      };
    };
    t = (function (f) {
      return {
        Na: f,
        La: function (g) {
          var d = [];
          return {
            start: function (c) {
              for (var b = 0; b < g.length; b++) d.push(f(g[b]));
              if (d.length)
                for (
                  var a = d.length,
                    e = function () {
                      !c.g() && 0 < a && (--a, 0 === a && c.b());
                    },
                    b = 0;
                  b < d.length;
                  b++
                )
                  d[b].ea(e);
              else c.b();
            },
            finish: function (c) {
              if (c.T()) for (c = 0; c < d.length; c++) d[c].ca();
            },
          };
        },
      };
    })(function (f) {
      function g() {
        null !== e && (clearTimeout(e), (e = null));
        try {
          'function' === typeof f.finish && f.finish(d);
        } catch (a) {}
        c = !0;
        b.C();
      }

      var d,
        c = !1,
        b = new C(),
        a = !1,
        e = null,
        k = !1;
      d = {
        g: function () {
          return c;
        },
        b: function () {
          c || g();
        },
        ea: function (a) {
          b.then(function () {
            a();
          });
        },
        ca: function () {
          c || ((a = !0), g());
        },
        T: function () {
          return a;
        },
        Xa: function () {
          return k;
        },
      };
      0 < f.u &&
        (e = setTimeout(function () {
          e = null;
          c || ((k = !0), g());
        }, f.u));
      try {
        f.start(d);
      } catch (h) {
        d.b();
      }
      return d;
    });
    H = (function (f, g) {
      function d(a) {
        if (!a) return (c = 4), null;
        if ((a = !f.O(a))) {
          var b = f.D();
          if (null !== b && 10 > b) return (c = 8), null;
        }
        return a;
      }

      var c, b, a;
      c = 3;
      a = null;
      b = '';
      return {
        o: function () {
          var e = g.j[5],
            k = null;
          return {
            start: function (h) {
              c = 3;
              a = null;
              b = '';
              var l = !1;
              try {
                var m = d(e);
                if (null !== m) {
                  try {
                    k = f.F();
                  } catch (p) {
                    c = 9;
                    return;
                  }
                  try {
                    k.open('GET', e, !0);
                  } catch (p) {
                    c = 1;
                    return;
                  }
                  f.R(k, g.l, function (e, d) {
                    try {
                      if (!h.g())
                        if (e) c = 2;
                        else if (d) c = 6;
                        else {
                          var f = k;
                          c = f.status;
                          200 === f.status &&
                            ((b = f.getResponseHeader('ETag') || '')
                              ? (b = b.replace(/"/g, ''))
                              : (c = 7));
                          b && (a = m);
                        }
                    } catch (g) {
                      c = 6;
                    } finally {
                      h.b();
                    }
                  });
                  l = !0;
                }
              } catch (p) {
                c = 6;
              } finally {
                l || h.b();
              }
            },
            finish: function (a) {
              a.T() && (c = 5);
              k = null;
            },
          };
        },
        wa: function () {
          return b;
        },
        M: function () {
          return a;
        },
        N: function () {
          return c;
        },
      };
    })(r, u, t);
    I = (function (f, g) {
      function d(a) {
        return f.O(a) || ((a = f.D()), 8 !== a && 9 !== a) ? !1 : !0;
      }

      function c(a, b, c) {
        function d() {
          a && !g && ((a.onload = a.onerror = a.ontimeout = null), (g = !0));
          a = null;
          c(f);
        }

        var f = !1,
          g = !1,
          p = !1;
        try {
          (a.onload = function () {
            f = !0;
            d();
          }),
            (a.onerror = a.ontimeout = d),
            (a.timeout = b),
            a.send(),
            (p = !0);
        } catch (z) {
        } finally {
          p || d();
        }
      }

      var b = null;
      return {
        o: function () {
          return {
            start: function (a) {
              try {
                var e = g.j[1],
                  k = g.j[2];
                if (e && k) {
                  var h;
                  (function (a, b) {
                    d(a)
                      ? ((h = new XDomainRequest()),
                        h.open('POST', a),
                        c(h, g.l, b))
                      : ((h = f.F()),
                        h.open('POST', a, !0),
                        f.R(h, g.l, function () {
                          b(200 === h.status);
                        }));
                  })(e, function (c) {
                    var e = new Date();
                    if (!a.g()) {
                      try {
                        if (c && h.responseText) {
                          var d = h.responseText.replace(/[^ -~](?:.|\n)*/, '');
                          f.Y(k).value = d;
                          b = e;
                        }
                      } catch (g) {}
                      a.b();
                    }
                  });
                } else a.b();
              } catch (l) {
                a.b();
              }
            },
          };
        },
        va: function () {
          return b;
        },
      };
    })(r, u, t);
    E = (function () {
      return {
        h: [],
        H: [],
        fa: function (f) {
          return {
            ja: f,
            J: [],
            Pa: function (f, d) {
              for (var c = 0; c < d.length; c++) this.J[f + c] = d[c];
            },
            da: function (f) {
              this.Pa(this.J.length, f);
            },
            A: function () {
              for (
                var f = this.J, d = this.ja.toString(), c = 0;
                c < f.length;
                c++
              )
                try {
                  for (
                    var b = (d += '&'),
                      a = '' + f[c](),
                      e = '',
                      k = /[%&]+/g,
                      h = void 0,
                      l = 0,
                      h = k.exec(a);
                    null !== h;

                  )
                    (e += a.substring(l, h.index) + encodeURIComponent(h[0])),
                      (l = k.lastIndex),
                      (h = k.exec(a));
                  e += a.substring(l);
                  d = b + e;
                } catch (m) {}
              return d;
            },
          };
        },
      };
    })();
    J = (function (f, g) {
      var d = !1,
        c = !1;
      return {
        oa: function () {
          return {
            start: function (b) {
              d = !1;
              try {
                (window.requestFileSystem || window.webkitRequestFileSystem)(
                  0,
                  0,
                  function () {
                    b.b();
                  },
                  function () {
                    b.g() || ((d = !0), b.b());
                  },
                );
              } catch (a) {
                b.b();
              }
            },
            u: g.l,
          };
        },
        ma: function () {
          var b =
              window.indexedDB ||
              window.mozIndexedDB ||
              window.webkitIndexedDB ||
              window.msIndexedDB,
            a;
          return {
            start: function (e) {
              c = !1;
              try {
                (a = b.open('pbtest')),
                  (a.onsuccess = function () {
                    if (!e.g())
                      try {
                        a.result.close();
                      } finally {
                        e.b();
                      }
                  }),
                  (a.onerror = function () {
                    e.g() || ((c = !0), e.b());
                  });
              } catch (d) {
                e.b();
              }
            },
            finish: function () {
              a && (a = a.onsuccess = a.onerror = null);
              b && b.deleteDatabase('pbtest');
            },
            u: g.l,
          };
        },
        L: function () {
          var b;
          if (!(b = d || c))
            a: {
              if ((b = window.localStorage))
                try {
                  b.setItem('pbtest', 1), b.removeItem('pbtest');
                } catch (a) {
                  b = !0;
                  break a;
                }
              b = !1;
            }
          b ||
            window.indexedDB ||
            ((b = f.D()), (b = (null !== b && 10 <= b) || f.I('Edge/')));
          b || (b = f.I('Focus/'));
          return b;
        },
      };
    })(r, u, t);
    y = (function (f) {
      var g = null;
      return {
        na: function () {
          var d,
            c = null;
          return {
            start: function (b) {
              g = null;
              try {
                (d = document.createElement('div')),
                  d.setAttribute(
                    'class',
                    'pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links adsbox',
                  ),
                  d.setAttribute(
                    'style',
                    f.G(
                      'width:1px;height:1px;position:absolute;left:-10000px;right:-1000px;',
                      ';',
                      '!important;',
                      !0,
                    ),
                  ),
                  document.body.appendChild(d),
                  (c = setTimeout(function () {
                    c = null;
                    if (!b.g())
                      try {
                        g = !(
                          d &&
                          d.parentNode &&
                          !d.getAttribute('abp') &&
                          d.offsetParent &&
                          0 !== d.offsetWidth &&
                          0 !== d.offsetHeight &&
                          0 !== d.clientWidth &&
                          0 !== d.clientHeight
                        );
                      } finally {
                        b.b();
                      }
                  }, 100));
              } catch (a) {
                b.b();
              }
            },
            finish: function () {
              d && (d.parentNode && d.parentNode.removeChild(d), (d = null));
              null !== c && (clearTimeout(c), (c = null));
            },
          };
        },
        L: function () {
          return g;
        },
      };
    })(r, u, t);
    K = (function () {
      function f(b) {
        var a;
        37 > b
          ? 11 > b
            ? b
              ? (a = b + 47)
              : (a = 46)
            : (a = b + 54)
          : 38 > b
          ? (a = 95)
          : (a = b + 59);
        return String.fromCharCode(a);
      }

      function g(b) {
        function a(a) {
          g = (g << a[0]) | a[1];
          for (h += a[0]; 6 <= h; )
            (a = (g >> (h - 6)) & 63), (c += f(a)), (h -= 6), (g ^= a << h);
        }

        var c = '',
          g = 0,
          h = 0;
        a([6, ((b.length & 7) << 3) | 0]);
        a([6, (b.length & 56) | 1]);
        for (var l = 0; l < b.length; l++) {
          if (void 0 === d[b.charCodeAt(l)]) return;
          a(d[b.charCodeAt(l)]);
        }
        a(d[0]);
        0 < h && a([6 - h, 0]);
        return c;
      }

      var d = {
          1: [4, 15],
          110: [8, 239],
          74: [8, 238],
          57: [7, 118],
          56: [7, 117],
          71: [8, 233],
          25: [8, 232],
          101: [5, 28],
          104: [7, 111],
          4: [7, 110],
          105: [6, 54],
          5: [7, 107],
          109: [7, 106],
          103: [9, 423],
          82: [9, 422],
          26: [8, 210],
          6: [7, 104],
          46: [6, 51],
          97: [6, 50],
          111: [6, 49],
          7: [7, 97],
          45: [7, 96],
          59: [5, 23],
          15: [7, 91],
          11: [8, 181],
          72: [8, 180],
          27: [8, 179],
          28: [8, 178],
          16: [7, 88],
          88: [10, 703],
          113: [11, 1405],
          89: [12, 2809],
          107: [13, 5617],
          90: [14, 11233],
          42: [15, 22465],
          64: [16, 44929],
          0: [16, 44928],
          81: [9, 350],
          29: [8, 174],
          118: [8, 173],
          30: [8, 172],
          98: [8, 171],
          12: [8, 170],
          99: [7, 84],
          117: [6, 41],
          112: [6, 40],
          102: [9, 319],
          68: [9, 318],
          31: [8, 158],
          100: [7, 78],
          84: [6, 38],
          55: [6, 37],
          17: [7, 73],
          8: [7, 72],
          9: [7, 71],
          77: [7, 70],
          18: [7, 69],
          65: [7, 68],
          48: [6, 33],
          116: [6, 32],
          10: [7, 63],
          121: [8, 125],
          78: [8, 124],
          80: [7, 61],
          69: [7, 60],
          119: [7, 59],
          13: [8, 117],
          79: [8, 116],
          19: [7, 57],
          67: [7, 56],
          114: [6, 27],
          83: [6, 26],
          115: [6, 25],
          14: [6, 24],
          122: [8, 95],
          95: [8, 94],
          76: [7, 46],
          24: [7, 45],
          37: [7, 44],
          50: [5, 10],
          51: [5, 9],
          108: [6, 17],
          22: [7, 33],
          120: [8, 65],
          66: [8, 64],
          21: [7, 31],
          106: [7, 30],
          47: [6, 14],
          53: [5, 6],
          49: [5, 5],
          86: [8, 39],
          85: [8, 38],
          23: [7, 18],
          75: [7, 17],
          20: [7, 16],
          2: [5, 3],
          73: [8, 23],
          43: [9, 45],
          87: [9, 44],
          70: [7, 10],
          3: [6, 4],
          52: [5, 1],
          54: [5, 0],
        },
        c =
          '%20 ;;; %3B %2C und fin ed; %28 %29 %3A /53 ike Web 0; .0 e; on il ck 01 in Mo fa 00 32 la .1 ri it %u le'.split(
            ' ',
          );
      return {
        U: function (b) {
          for (var a = b, e = 0; c[e]; e++)
            a = a.split(c[e]).join(String.fromCharCode(e + 1));
          a = g(a);
          if (void 0 === a) return b;
          for (var e = 65535, d = 0; d < b.length; d++)
            (e = ((e >>> 8) | (e << 8)) & 65535),
              (e ^= b.charCodeAt(d) & 255),
              (e ^= (e & 255) >> 4),
              (e ^= (e << 12) & 65535),
              (e ^= ((e & 255) << 5) & 65535);
          e &= 65535;
          b = '' + f(e >>> 12);
          b += f((e >>> 6) & 63);
          b += f(e & 63);
          return a + b;
        },
      };
    })();
    L = (function (f) {
      function g() {
        q || (q = z);
        try {
          isNaN(screen.logicalXDPI) || isNaN(screen.systemXDPI)
            ? window.navigator.msMaxTouchPoints
              ? (q = m)
              : !window.chrome || window.opera || f.I(' Opera')
              ? 0 <=
                Object.prototype.toString
                  .call(window.HTMLElement)
                  .indexOf('Constructor')
                ? (q = h)
                : 'orientation' in window &&
                  'webkitRequestAnimationFrame' in window
                ? (q = k)
                : 'webkitRequestAnimationFrame' in window
                ? (q = e)
                : f.I('Opera')
                ? (q = d)
                : window.devicePixelRatio
                ? (q = c)
                : 0.001 < b().zoom && (q = b)
              : (q = l)
            : (q = p);
        } catch (a) {}
        return q();
      }

      function d() {
        var a = window.top.outerWidth / window.top.innerWidth,
          a = Math.round(100 * a) / 100;
        return { zoom: a, i: a * w() };
      }

      function c() {
        return { zoom: b().zoom, i: w() };
      }

      function b() {
        var b = a(),
          b = Math.round(100 * b) / 100;
        return { zoom: b, i: b };
      }

      function a() {
        function a(c, e, d) {
          var f = (c + e) / 2;
          return 0 >= d || 1e-4 > e - c
            ? f
            : b('(min--moz-device-pixel-ratio:' + f + ')').matches
            ? a(f, e, d - 1)
            : a(c, f, d - 1);
        }

        var b, c, e, d;
        window.matchMedia
          ? (b = window.matchMedia)
          : ((c = document.getElementsByTagName('head')[0]),
            (e = document.createElement('style')),
            c.appendChild(e),
            (d = document.createElement('div')),
            (d.className = 'mediaQueryBinarySearch'),
            (d.style.display = 'none'),
            document.body.appendChild(d),
            (b = function (a) {
              e.sheet.insertRule(
                '@media ' +
                  a +
                  '{.mediaQueryBinarySearch {text-decoration: underline} }',
                0,
              );
              a = 'underline' === getComputedStyle(d, null).textDecoration;
              e.sheet.deleteRule(0);
              return { matches: a };
            }));
        var f = a(0, 10, 20);
        d && (c.removeChild(e), document.body.removeChild(d));
        return f;
      }

      function e() {
        var a = document.createElement('div');
        a.innerHTML = '1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br>0';
        a.setAttribute(
          'style',
          'font: 100px/1em sans-serif; -webkit-text-size-adjust: none; text-size-adjust: none; height: auto; width: 1em; padding: 0; overflow: visible;'.replace(
            /;/g,
            ' !important;',
          ),
        );
        var b = document.createElement('div');
        b.setAttribute(
          'style',
          'width:0; height:0; overflow:hidden; visibility:hidden; position: absolute;'.replace(
            /;/g,
            ' !important;',
          ),
        );
        b.appendChild(a);
        document.body.appendChild(b);
        a = 1e3 / a.clientHeight;
        a = Math.round(100 * a) / 100;
        document.body.removeChild(b);
        return { zoom: a, i: a * w() };
      }

      function k() {
        var a =
          (90 == Math.abs(window.orientation) ? screen.height : screen.width) /
          window.innerWidth;
        return { zoom: a, i: a * w() };
      }

      function h() {
        var a =
          Math.round(
            (document.documentElement.clientWidth / window.innerWidth) * 100,
          ) / 100;
        return { zoom: a, i: a * w() };
      }

      function l() {
        var a = Math.round((window.outerWidth / window.innerWidth) * 100) / 100;
        return { zoom: a, i: a * w() };
      }

      function m() {
        var a =
          Math.round(
            (document.documentElement.offsetHeight / window.innerHeight) * 100,
          ) / 100;
        return { zoom: a, i: a * w() };
      }

      function p() {
        var a =
          Math.round((screen.deviceXDPI / screen.logicalXDPI) * 100) / 100;
        return { zoom: a, i: a * w() };
      }

      function z() {
        return { zoom: 1, i: 1 };
      }

      function w() {
        return window.devicePixelRatio || 1;
      }

      var q;
      return {
        zoom: function () {
          return g().zoom;
        },
        V: function () {
          return g().i;
        },
      };
    })(r);
    M = (function () {
      var f = {
          Flash: [
            'ShockwaveFlash.ShockwaveFlash',
            function (c) {
              return c.getVariable('$version');
            },
          ],
          Director: [
            'SWCtl.SWCtl',
            function (c) {
              return c.ShockwaveVersion('');
            },
          ],
        },
        g;
      try {
        (g = document.createElement('span')),
          'undefined' !== typeof g.addBehavior &&
            g.addBehavior('#default#clientCaps');
      } catch (c) {}
      var d = {};
      return {
        f: function (c) {
          var b = '';
          try {
            'undefined' !== typeof g.getComponentVersion &&
              (b = g.getComponentVersion(c, 'ComponentID'));
          } catch (a) {
            (c = a.message.length),
              (b = escape(a.message.substr(0, 40 < c ? 40 : c)));
          }
          return b;
        },
        s: function (c) {
          return d[c];
        },
        ra: function () {
          for (
            var c =
                'Acrobat;Flash;QuickTime;Java Plug-in;Director;Office'.split(
                  ';',
                ),
              b = 0;
            b < c.length;
            b++
          ) {
            var a = c[b],
              e = a,
              g = a,
              a = '';
            try {
              if (navigator.plugins && navigator.plugins.length)
                for (
                  var h = new RegExp(g + '.* ([0-9._]+)'), g = 0;
                  g < navigator.plugins.length;
                  g++
                ) {
                  var l = h.exec(navigator.plugins[g].name);
                  null === l && (l = h.exec(navigator.plugins[g].description));
                  l && (a = l[1]);
                }
              else if (window.ActiveXObject && f[g])
                try {
                  var m = new ActiveXObject(f[g][0]),
                    a = f[g][1](m);
                } catch (p) {
                  a = '';
                }
            } catch (p) {
              a = p.message;
            }
            d[e] = a;
          }
        },
        c: function (c) {
          try {
            if (navigator.plugins && navigator.plugins.length)
              for (var b = 0; b < navigator.plugins.length; b++) {
                var a = navigator.plugins[b];
                if (0 <= a.name.indexOf(c))
                  return a.name + (a.description ? '|' + a.description : '');
              }
          } catch (e) {}
          return '';
        },
        ya: function () {
          var c = '';
          if (navigator.plugins && navigator.plugins.length)
            for (var b = 0; b < navigator.plugins.length; b++) {
              var a = navigator.plugins[b];
              a && (c += a.name + a.filename + a.description + a.version);
            }
          return c;
        },
      };
    })();
    N = (function (f, g) {
      function d(b) {
        a = b.status;
        var c = ['', '', ''];
        try {
          h = b.getResponseHeader('cache-control');
          for (
            var d = b.getAllResponseHeaders().toLowerCase().split('\n'),
              g = ['warning', 'x-cache', 'via'],
              k = 0;
            k < g.length;
            k++
          )
            for (var x = 0; x < d.length; x++)
              if (f.startsWith(d[x], g[k] + ':')) {
                c[k] = b.getResponseHeader(g[k]);
                break;
              }
        } catch (r) {}
        l = c[0];
        m = c[1];
        p = c[2];
        200 === b.status &&
          ((b = b.getResponseHeader('Last-Modified')) ||
            ((b = (void 0).getResponseHeader('Expires'))
              ? ((b = new Date(b)),
                b.setTime(b.getTime() - 31536e6),
                (b = b.toUTCString()))
              : (b = void 0)),
          (e = b || '') || (a = 7));
      }

      function c(b) {
        if (!b) return (a = 4), null;
        if ((b = !f.O(b))) {
          var c = f.D();
          if (null !== c && 10 > c) return (a = 8), null;
        }
        return b;
      }

      function b() {
        a = 3;
        k = null;
        e = h = l = m = p = '';
      }

      var a, e, k, h, l, m, p;
      b();
      return {
        o: function () {
          var h = g.j[0],
            l = null;
          return {
            start: function (q) {
              b();
              var m = !1;
              try {
                var p = c(h);
                if (null !== p) {
                  try {
                    l = f.F();
                  } catch (x) {
                    a = 9;
                    return;
                  }
                  try {
                    l.open('GET', h, !0);
                  } catch (x) {
                    a = 1;
                    return;
                  }
                  f.R(l, g.l, function (b, c) {
                    try {
                      q.g() ||
                        (b ? (a = 2) : c ? (a = 6) : (d(l), e && (k = p)));
                    } catch (f) {
                      a = 6;
                    } finally {
                      q.b();
                    }
                  });
                  m = !0;
                }
              } catch (x) {
                a = 6;
              } finally {
                m || q.b();
              }
            },
            finish: function (b) {
              b.T() && (a = 5);
              l = null;
            },
          };
        },
        Qa: function () {
          try {
            var h = g.j[0];
            b();
            var l = c(h);
            if (null !== l) {
              var m;
              try {
                m = f.F();
              } catch (p) {
                a = 9;
                return;
              }
              try {
                m.open('GET', h, !1);
              } catch (p) {
                a = 1;
                return;
              }
              m.send();
              d(m);
              e && (k = l);
            }
          } catch (p) {
            a = 6;
          }
        },
        xa: function () {
          return e;
        },
        M: function () {
          return k;
        },
        N: function () {
          return a;
        },
        ua: function () {
          return h;
        },
        Da: function () {
          return l;
        },
        Fa: function () {
          return m;
        },
        Ca: function () {
          return p;
        },
      };
    })(r, u, t);
    O = (function () {
      function f(a) {
        d = new Date(a.getTime());
        c = g(1);
        b = g(7);
      }

      function g(a) {
        a--;
        var b = d.getTime(),
          c = d.getFullYear(),
          f = new Date(c, a, 15),
          g = f,
          m = f;
        f.getTime() <= b
          ? (m = new Date(c + 1, a, 15))
          : (g = new Date(c - 1, a, 15));
        return (b - g.getTime() < m.getTime() - b ? g : m).getTimezoneOffset();
      }

      var d, c, b;
      f(new Date());
      return {
        Oa: f,
        Ea: function () {
          return c;
        },
        Aa: function () {
          return b;
        },
        Ja: function () {
          return b !== c;
        },
        Ia: function () {
          return b !== c && d.getTimezoneOffset() === Math.min(c, b);
        },
        za: function () {
          return Math.max(c, b);
        },
      };
    })();
    D = (function () {
      function f(c) {
        return d && 'function' === typeof c ? c.apply(this) : '';
      }

      var g = {
          platform: '',
          platformVersion: '',
          architecture: '',
          model: '',
          uaFullVersion: '',
        },
        d = void 0 !== navigator.userAgentData;
      return {
        ka: d,
        Ka: function () {
          return f(function () {
            try {
              return navigator.userAgentData.mobile;
            } catch (c) {
              return '';
            }
          });
        },
        X: function () {
          return f(function () {
            try {
              return navigator.userAgentData.brands[0].brand;
            } catch (c) {
              return '';
            }
          });
        },
        ta: function () {
          return f(function () {
            try {
              return navigator.userAgentData.brands[0].version;
            } catch (c) {
              return '';
            }
          });
        },
        qa: function () {
          return {
            start: function (c) {
              try {
                d
                  ? navigator.userAgentData
                      .getHighEntropyValues(Object.keys(g))
                      .then(function (b) {
                        c.g() || ((g = b), c.b());
                      })
                  : c.b();
              } catch (b) {
                c.b();
              }
            },
          };
        },
        aa: function () {
          return g.platform;
        },
        ba: function () {
          return g.platformVersion;
        },
        W: function () {
          return g.architecture;
        },
        $: function () {
          return g.model;
        },
        Z: function () {
          return g.uaFullVersion;
        },
      };
    })();
    y = (function (f, g, d, c, b, a, e, k, h, l, m, p) {
      function z(a) {
        q();
        a = a || b.Ma;
        try {
          if (!a) return r();
          var c;
          c = d.Y(a);
          if (null === c || void 0 === c) return r();
          try {
            var e = r();
            return (c.value = e);
          } catch (f) {
            c.value = escape(f.message);
          }
        } catch (f) {}
      }

      function w(a, c) {
        q();
        var d = Math.random() + 1 && [
          'https://globalsiteanalytics.com/resource/resource.png',
          'https://globalsiteanalytics.com/service/hdim',
          'user_prefs2',
        ];
        c ? (b.j = c) : (b.j = 'string' !== typeof d ? d : []);
        A(b.K, a);
        for (d = 0; d < b.S.length; d++) b.S[d]();
      }

      function q() {
        b.w && (b.w.ca(), (b.w = null));
      }

      function A(a, c) {
        for (var d = [], e = 0; e < a.length; e++)
          try {
            d.push(a[e]());
          } catch (f) {}
        d = h.La(d);
        d = h.Na(d);
        'function' === typeof c && d.ea(c);
        b.w = d;
      }

      function r() {
        B = new Date();
        l.Oa(B);
        e.ra();
        for (var c = '', d = 0; d < a.h.length; d++) {
          var f;
          try {
            f = a.h[d]();
          } catch (h) {
            f = '';
          }
          c += escape(f);
          c += ';';
        }
        c += escape(b.v.A()) + ';';
        for (d = 0; d < a.H.length; d++) c = a.H[d](c);
        return u ? g.U(c) : c;
      }

      function x(a) {
        return function () {
          return a;
        };
      }

      var u = !0,
        t = {},
        y = '',
        n = x('');
      b.v = new a.fa(3);
      b.v.da([
        function () {
          return y;
        },
        function () {
          return k.ua();
        },
        function () {
          return k
            .Da()
            .replace(
              / *(\d{3}) [^ ]*( "[^"\\]*(\\(.|\n)[^"\\]*)*"){1,2} */g,
              function (a, b) {
                return b;
              },
            );
        },
        function () {
          return k.Fa();
        },
        function () {
          return k.Ca();
        },
        function () {
          var a = f.L();
          return 'boolean' === typeof a ? 0 + a : '';
        },
        function () {
          return d.a('devicePixelRatio');
        },
        function () {
          return Math.round(window.screen.width * c.V());
        },
        function () {
          return Math.round(window.screen.height * c.V());
        },
        function () {
          return d.a('screen.left');
        },
        function () {
          return d.a('screen.top');
        },
        function () {
          return d.a('innerWidth');
        },
        function () {
          return d.a('outerWidth');
        },
        function () {
          return c.zoom().toFixed(2);
        },
        function () {
          return d.a('navigator.languages');
        },
      ]);
      var B;
      a.h = [
        x('TF1'),
        x('030'),
        function () {
          return ScriptEngineMajorVersion();
        },
        function () {
          return ScriptEngineMinorVersion();
        },
        function () {
          return ScriptEngineBuildVersion();
        },
        function () {
          return e.f('{7790769C-0471-11D2-AF11-00C04FA35D02}');
        },
        function () {
          return e.f('{89820200-ECBD-11CF-8B85-00AA005B4340}');
        },
        function () {
          return e.f('{283807B5-2C60-11D0-A31D-00AA00B92C03}');
        },
        function () {
          return e.f('{4F216970-C90C-11D1-B5C7-0000F8051515}');
        },
        function () {
          return e.f('{44BBA848-CC51-11CF-AAFA-00AA00B6015C}');
        },
        function () {
          return e.f('{9381D8F2-0288-11D0-9501-00AA00B911A5}');
        },
        function () {
          return e.f('{4F216970-C90C-11D1-B5C7-0000F8051515}');
        },
        function () {
          return e.f('{5A8D6EE0-3E18-11D0-821E-444553540000}');
        },
        function () {
          return e.f('{89820200-ECBD-11CF-8B85-00AA005B4383}');
        },
        function () {
          return e.f('{08B0E5C0-4FCB-11CF-AAA5-00401C608555}');
        },
        function () {
          return e.f('{45EA75A0-A269-11D1-B5BF-0000F8051515}');
        },
        function () {
          return e.f('{DE5AED00-A4BF-11D1-9948-00C04F98BBC9}');
        },
        function () {
          return e.f('{22D6F312-B0F6-11D0-94AB-0080C74C7E95}');
        },
        function () {
          return e.f('{44BBA842-CC51-11CF-AAFA-00AA00B6015B}');
        },
        function () {
          return e.f('{3AF36230-A269-11D1-B5BF-0000F8051515}');
        },
        function () {
          return e.f('{44BBA840-CC51-11CF-AAFA-00AA00B6015C}');
        },
        function () {
          return e.f('{CC2A9BA0-3BDD-11D0-821E-444553540000}');
        },
        function () {
          return e.f('{08B0E5C0-4FCB-11CF-AAA5-00401C608500}');
        },
        function () {
          return d.a('navigator.appCodeName');
        },
        function () {
          return d.a('navigator.appName');
        },
        function () {
          return d.a('navigator.appVersion');
        },
        function () {
          return d.B(['navigator.productSub', 'navigator.appMinorVersion']);
        },
        function () {
          return d.a('navigator.browserLanguage');
        },
        function () {
          return d.a('navigator.cookieEnabled');
        },
        function () {
          return d.B(['navigator.oscpu', 'navigator.cpuClass']);
        },
        n,
        function () {
          return d.a('navigator.platform');
        },
        function () {
          return d.a('navigator.systemLanguage');
        },
        function () {
          return p.A();
        },
        function () {
          return d.B(['navigator.language', 'navigator.userLanguage']);
        },
        function () {
          return d.a('document.defaultCharset');
        },
        function () {
          return d.a('document.domain');
        },
        function () {
          return d.a('screen.deviceXDPI');
        },
        function () {
          return d.a('screen.deviceYDPI');
        },
        function () {
          return d.a('screen.fontSmoothingEnabled');
        },
        function () {
          return d.a('screen.updateInterval');
        },
        function () {
          return l.Ja();
        },
        function () {
          return l.Ia();
        },
        function () {
          return '@UTC@';
        },
        function () {
          return -l.za() / 60;
        },
        function () {
          return new Date(2005, 5, 7, 21, 33, 44, 888)
            .toLocaleString()
            .replace(/\u200e/g, '');
        },
        function () {
          return d.a('screen.width');
        },
        function () {
          return d.a('screen.height');
        },
        function () {
          return e.s('Acrobat');
        },
        function () {
          return e.s('Flash');
        },
        function () {
          return e.s('QuickTime');
        },
        function () {
          return e.s('Java Plug-in');
        },
        function () {
          return e.s('Director');
        },
        function () {
          return e.s('Office');
        },
        function () {
          return '@CT@';
        },
        function () {
          return l.Ea();
        },
        function () {
          return l.Aa();
        },
        function () {
          return B.toLocaleString().replace(/\u200e/g, '');
        },
        function () {
          return d.a('screen.colorDepth');
        },
        function () {
          return d.a('screen.availWidth');
        },
        function () {
          return d.a('screen.availHeight');
        },
        function () {
          return d.a('screen.availLeft');
        },
        function () {
          return d.a('screen.availTop');
        },
        function () {
          return e.c('Acrobat');
        },
        function () {
          return e.c('Adobe SVG');
        },
        function () {
          return e.c('Authorware');
        },
        function () {
          return e.c('Citrix ICA');
        },
        function () {
          return e.c('Director');
        },
        function () {
          return e.c('Flash');
        },
        function () {
          return e.c('MapGuide');
        },
        function () {
          return e.c('MetaStream');
        },
        function () {
          return e.c('PDF Viewer');
        },
        function () {
          return e.c('QuickTime');
        },
        function () {
          return e.c('RealOne');
        },
        function () {
          return e.c('RealPlayer Enterprise');
        },
        function () {
          return e.c('RealPlayer Plugin');
        },
        function () {
          return e.c('Seagate Software Report');
        },
        function () {
          return e.c('Silverlight');
        },
        function () {
          return e.c('Windows Media');
        },
        function () {
          return e.c('iPIX');
        },
        function () {
          return e.c('nppdf.so');
        },
        function () {
          var a = document.createElement('span');
          a.innerHTML = '&nbsp;';
          a.style.position = 'absolute';
          a.style.left = '-9999px';
          document.body.appendChild(a);
          var b = a.offsetHeight;
          document.body.removeChild(a);
          return b;
        },
        n,
        n,
        n,
        n,
        n,
        n,
        n,
        n,
        n,
        n,
        n,
        n,
        n,
        n,
        function () {
          return '7.2.0-0';
        },
        n,
        function () {
          return k.xa();
        },
        n,
        n,
        n,
        n,
        n,
        function () {
          var a = k.M();
          return 'boolean' === typeof a ? 0 + a : '';
        },
        function () {
          return k.N();
        },
        function () {
          return '0';
        },
        n,
        n,
        n,
        n,
        function () {
          return (d.Ga(e.ya()) >>> 0).toString(16) + '';
        },
        function () {
          return d.B(['navigator.doNotTrack', 'navigator.msDoNotTrack']);
        },
        n,
        n,
        n,
        n,
        n,
        n,
        function () {
          return m.Ka();
        },
        function () {
          return m.X();
        },
        function () {
          return m.ta();
        },
        function () {
          return m.aa();
        },
        function () {
          return m.ba();
        },
        function () {
          return m.W();
        },
        function () {
          return m.$();
        },
        function () {
          return m.Z();
        },
      ];
      a.H = [
        function (a) {
          return d.G(a, escape('@UTC@'), new Date().getTime());
        },
        function (a) {
          return d.G(a, escape('@CT@'), new Date().getTime() - B.getTime());
        },
      ];
      b.K.push(
        k.o,
        function () {
          return {
            start: function (a) {
              y = '';
              try {
                navigator.getBattery().then(function (b) {
                  a.g() ||
                    ((y = [
                      b.charging,
                      b.chargingTime,
                      b.dischargingTime,
                      b.level,
                    ].join()),
                    a.b());
                });
              } catch (b) {
                a.b();
              }
            },
            u: b.l,
          };
        },
        f.na,
        m.qa,
      );
      t.validate = z;
      t.f1b5 = g.U;
      t.initiate = w;
      t.generate = function (a, c, d) {
        q();
        b.j = [a];
        2 < arguments.length ? A([k.o], d) : k.Qa();
      };
      return function (a) {
        a = a || {};
        var b = a.ctx || window;
        u = a.hasOwnProperty('compress') ? a.compress : !0;
        b.nstim = t;
        u &&
          ((a = navigator.userAgent.toLowerCase()),
          'Gecko' === navigator.product &&
            2 >=
              parseInt(
                a
                  .substring(
                    a.indexOf('rv:') + 3,
                    a.indexOf(')', a.indexOf('rv:') + 3),
                  )
                  .split('.')[0],
                10,
              ) &&
            z());
        return { A: z, Wa: w };
      };
    })(
      y,
      K,
      r,
      L,
      u,
      E,
      M,
      N,
      t,
      O,
      D,
      (function (f, g, d, c) {
        return {
          A: function () {
            if (!f.ka) return g.a('navigator.userAgent');
            var b = f.X();
            if (-1 === b.toLowerCase().indexOf('chrome'))
              return g.a('navigator.userAgent');
            var a = f.aa(),
              b = {
                CH_architecture: f.W(),
                CH_platform: a,
                CH_platformVersion: f.ba(),
                CH_BrowserName: b.replace('Google ', ''),
                CH_UAFullVersion: f.Z(),
                CH_model: f.$(),
              };
            return -1 < a.toLowerCase().indexOf('mac os')
              ? c.P(d.ga, b)
              : -1 < a.toLowerCase().indexOf('windows')
              ? c.P(d.ia, b)
              : -1 < a.toLowerCase().indexOf('android')
              ? c.P(d.ha, b)
              : g.a('navigator.userAgent');
          },
        };
      })(
        D,
        r,
        {
          ga: 'Mozilla/5.0 (Macintosh; {{CH_architecture}} {{CH_platform}} {{CH_platformVersion}}) AppleWebKit/537.36 (KHTML, like Gecko) {{CH_BrowserName}}/{{CH_UAFullVersion}} Safari/537.36',
          ia: 'Mozilla/5.0 ({{CH_platform}} NT {{CH_platformVersion}}; {{CH_architecture}}) AppleWebKit/537.36 (KHTML, like Gecko) {{CH_BrowserName}}/{{CH_UAFullVersion}} Safari/537.36',
          ha: 'Mozilla/5.0 (Linux; {{CH_platform}} {{CH_platformVersion}}; {{CH_model}}) AppleWebKit/537.36 (KHTML, like Gecko) {{CH_BrowserName}}/{{CH_UAFullVersion}} Mobile Safari/537.36',
        },
        {
          P: function (f, g) {
            for (var d in g)
              g.hasOwnProperty(d) && (f = f.replace('{{' + d + '}}', g[d]));
            return f;
          },
        },
      ),
    );
    (function (f) {
      'undefined' !== typeof F ? f(F) : f();
    })(
      (function (f, g, d, c, b, a, e, k, h, l, m) {
        var p = '',
          r = '';
        a.H[0] = function (a) {
          return f.G(a, escape('@UTC@'), (b.va() || new Date()).getTime());
        };
        a.h[106] = function () {
          return '1';
        };
        a.h[108] = function () {
          return p;
        };
        a.h[109] = function () {
          return r;
        };
        a.h[110] = function () {
          return g(new Date().getTime());
        };
        a.h[113] = function () {
          return 0 + e.L();
        };
        a.h[114] = function () {
          return d.wa();
        };
        a.h[115] = function () {
          var a = d.M();
          return 'boolean' === typeof a ? 0 + a : '';
        };
        a.h[116] = function () {
          return d.N();
        };
        a.h[118] = function () {
          return m.Ba() || '';
        };
        c.v.da([
          function () {
            return l.sa();
          },
        ]);
        c.K.push(b.o, d.o, l.pa, e.ma, e.oa);
        c.S.push(function () {
          p = r = '';
          var a = c.j,
            b = a[3];
          if (b) {
            a = a[4];
            a: {
              for (
                var d = b + '=', e = document.cookie.split(/; */g), f = 0;
                f < e.length;
                f++
              ) {
                var h = e[f];
                if (0 === h.indexOf(d)) {
                  r = h.substring(d.length, h.length);
                  break a;
                }
              }
              r = '';
            }
            r
              ? (p = '0')
              : ((d = new Date().getTime()),
                (r = g(d)),
                (document.cookie =
                  b +
                  '=' +
                  r +
                  '; expires=' +
                  new Date(d + 63072e6).toUTCString() +
                  (a ? '; domain=.' + a : '') +
                  '; path=/'),
                (p = '1'));
          }
        });
        return function (a) {
          k(a);
        };
      })(
        r,
        G,
        H,
        u,
        I,
        E,
        J,
        y,
        t,
        (function (f, g) {
          function d(a, b, c) {
            function d(a) {
              m.reject(a);
            }

            function f(a) {
              m.C(a);
            }

            var m = new g();
            try {
              try {
                a[b].apply(a, c).then(f, d);
              } catch (p) {
                a[b].apply(a, c.concat([f, d]));
              }
            } catch (p) {
              d(p);
            }
            return m;
          }

          var c =
              window.mozRTCPeerConnection ||
              window.webkitRTCPeerConnection ||
              window.RTCPeerConnection,
            b = [];
          return {
            pa: function () {
              var a = null,
                e = null;
              return {
                start: function (f) {
                  try {
                    (b = []),
                      (a = new c({ iceServers: [] })),
                      (a.onicecandidate = function (a) {
                        if (!f.g()) {
                          var c;
                          a: {
                            try {
                              var d = a.candidate;
                              if (d) {
                                var e = d.candidate;
                                if (e) {
                                  b.push(e);
                                  c = !0;
                                  break a;
                                }
                              }
                            } catch (g) {}
                            c = !1;
                          }
                          c || f.b();
                        }
                      }),
                      (e = a.createDataChannel('')),
                      d(a, 'createOffer', [])
                        .then(function (b) {
                          if (!f.g()) return d(a, 'setLocalDescription', [b]);
                        })
                        .then(null, function () {
                          f.g() || f.b();
                        });
                  } catch (g) {
                    f.b();
                  }
                },
                finish: function () {
                  a &&
                    ((a.onicecandidate = null),
                    e && (e.close(), (e = null)),
                    a.close(),
                    (a = null));
                },
                u: f.l,
              };
            },
            sa: function () {
              for (var a = '', c = '', d = 0; d < b.length; d++) {
                var f = b[d].replace(/^[^:]*:/, '').split(' ');
                8 <= f.length && ((a += c + f[4] + ' ' + f[7]), (c = ','));
              }
              return a;
            },
          };
        })(u, C),
        (function () {
          var f = ['webgl', 'experimental-webgl', 'moz-webgl', 'webkit-3d'],
            g = /android|\badr\b|silk|kindle/i;
          return {
            Ba: function () {
              if (
                window.WebGLRenderingContext &&
                !g.test(navigator.userAgent)
              ) {
                for (
                  var d = document.createElement('canvas'), c = null, b = 0;
                  b < f.length && !c;
                  b++
                )
                  c = d.getContext(f[b]);
                if (null !== c && c.getExtension('WEBGL_debug_renderer_info'))
                  return c.getParameter(37446);
              }
              return null;
            },
            Ra: function () {
              if (!window.WebGLRenderingContext) throw Error();
              var d = {
                m: null,
                la: null,
                Ua: function (c) {
                  return this.m.getParameter(c);
                },
                Sa: function (c) {
                  return this.m.getContextAttributes()[c];
                },
                Va: function (c, b) {
                  return this.m.getShaderPrecisionFormat(c, b);
                },
                Ta: function () {
                  return this.m.getSupportedExtensions();
                },
                Ha: function () {
                  if (!this.m) {
                    for (
                      var c = document.createElement('canvas'), b = 0;
                      b < f.length;
                      b++
                    ) {
                      var a = f[b];
                      if ((this.m = c.getContext(a))) {
                        this.la = a;
                        return;
                      }
                    }
                    throw Error();
                  }
                },
              };
              d.Ha();
              return d;
            },
          };
        })(),
      ),
    );
  })();
}
